// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#authentication{display:flex;align-items:center;justify-content:center;flex-direction:column;height:100vh}#authentication .rc-autocomplete{margin:1em 0}#authentication button{margin:2em 0 1em 0}", ""]);
// Exports
module.exports = exports;
